// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dropdown-menu__item:focus,.el-dropdown-menu__item:not(.is-disabled):hover{background-color:#9db4de;color:#1c6dfe}#mainPageSwitch span{display:inline-block;max-width:5.208vw;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
